import * as React from 'react'
import { FormControl } from 'react-bootstrap'
import LocalizationStore from '../../Stores/LocalizationStore'

export interface ILoginPageProps {
}

export default class LoginPage extends React.Component<ILoginPageProps> {

    constructor(props: any) {
        super(props)
    }

    login(e: React.FormEvent<FormControl>): void {
        e.preventDefault()
    }

    render() {
        let ls = LocalizationStore.getInstance()!

        return (
            <div>
                <p className="staticInfo">{ls.t!('Not found page')}</p>
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/Pages/NotFound.tsx